import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface AdminAuthGuardProps {
  children: React.ReactNode;
}

export const AdminAuthGuard = ({ children }: AdminAuthGuardProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    checkAdminAccess();
  }, []);

  const checkAdminAccess = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      navigate("/auth");
      return;
    }

    const { data: hasAdminRole } = await supabase.rpc('has_role', {
      user_id: session.user.id,
      role: 'admin'
    });

    if (!hasAdminRole) {
      toast({
        title: "Adgang nægtet",
        description: "Du har ikke adgang til admin dashboard'et",
        variant: "destructive",
      });
      navigate("/");
    }
  };

  return <>{children}</>;
};